import { render, staticRenderFns } from "./orderListDetail.vue?vue&type=template&id=6ec5f515&scoped=true"
import script from "./orderListDetail.vue?vue&type=script&lang=js"
export * from "./orderListDetail.vue?vue&type=script&lang=js"
import style0 from "./orderListDetail.vue?vue&type=style&index=0&id=6ec5f515&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5f515",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec5f515')) {
      api.createRecord('6ec5f515', component.options)
    } else {
      api.reload('6ec5f515', component.options)
    }
    module.hot.accept("./orderListDetail.vue?vue&type=template&id=6ec5f515&scoped=true", function () {
      api.rerender('6ec5f515', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/order/orderListDetail.vue"
export default component.exports